export enum ServiceEnum {
    name = "name",
    description = "description",
    price = "price",
    duration = "duration",
    serviceCategoryName = "serviceCategoryName",
    credits = "credits",
    active = "active",
}